import {
    DeliveryStatus,
    DurationType,
    PaymentStatus,
    ProductStatus,
    ProductType,
    Role,
    ZatcaPhase,
} from "../types";

export interface Option<T extends string = string> {
    value: T;
    label: string;
}

export const PRODUCT_TYPES: Option<ProductType>[] = [
    { value: "HARDWARE", label: "Hardware" },
    { value: "SOFTWARE", label: "Software" },
];

export const ZATCA_PHASES: Option<ZatcaPhase>[] = [
    { value: "PHASE_1", label: "Phase 1" },
    { value: "PHASE_2", label: "Phase 2" },
];

export const DURATION_TYPES: Option<DurationType>[] = [
    { value: "DAY", label: "Day(s)" },
    { value: "WEEK", label: "Week(s)" },
    { value: "MONTH", label: "Month(s)" },
    { value: "YEAR", label: "Year(s)" },
];

export const PRODUCT_STATUSES: Option<ProductStatus>[] = [
    { value: "ACTIVE", label: "Active" },
    { value: "PENDING", label: "Pending" },
    { value: "SUSPENDED", label: "Suspended" },
    { value: "CANCELLED", label: "Cancelled" },
];

export const PAYMENT_STATUSES: Option<PaymentStatus>[] = [
    { value: "PAID", label: "Paid" },
    { value: "PARTIALLY_PAID", label: "Partially paid" },
    { value: "NOT_PAID", label: "Not paid" },
];

export const DELIVERY_STATUSES: Option<DeliveryStatus>[] = [
    { value: "PENDING", label: "Pending" },
    { value: "IN_PROGRESS", label: "In progress" },
    { value: "DELIVERED", label: "Delivered" },
    { value: "CANCELLED", label: "Cancelled" },
];

export const CREATABLE_ROLES: Option<Exclude<Role, "SUPERADMIN">>[] = [
    { value: "RESELLER", label: "Reseller" },
    { value: "USER", label: "User (customer login)" },
    { value: "DEVELOPER", label: "Developer" },
];

export const ALL_ROLES: Option<Role>[] = [
    { value: "SUPERADMIN", label: "Super admin" },
    { value: "RESELLER", label: "Reseller" },
    { value: "DEVELOPER", label: "Developer" },
    { value: "USER", label: "User" },
];

export const USER_STATUSES: Option<"active" | "inactive">[] = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
];

export const labelOf = <T extends string>(options: Option<T>[], value: T | null | undefined): string =>
    options.find((o) => o.value === value)?.label ?? "—";   